import React, { useEffect, useState } from "react";
import axios from "axios";
import { Navigate, useLocation } from "react-router-dom";
import { API_BASE_URL } from "../config";

const ValidateAuthSession = ({
  children,
  tokenKey = "auth_token",
  validatePath = "/api/validate",
  redirectTo = "/signin",
  onUnauthed = () => {},
}) => {
  const [status, setStatus] = useState("loading"); // loading | authed | unauthed
  const location = useLocation();
  const token = localStorage.getItem(tokenKey);

  useEffect(() => {
    if (!token) {
      setStatus("unauthed");
      return;
    }

    let cancelled = false;

    axios
      .get(`${API_BASE_URL}${validatePath}`, {
        headers: { Authorization: `Bearer ${token}` }, // IMPORTANT
      })
      .then(() => {
        if (!cancelled) setStatus("authed");
      })
      .catch(() => {
        if (cancelled) return;

        localStorage.removeItem(tokenKey);
        onUnauthed();
        setStatus("unauthed");
      });

    return () => {
      cancelled = true;
    };
  }, [token, tokenKey, validatePath, onUnauthed]);

  if (status === "loading") return null;
  if (status === "unauthed") {
    return <Navigate to={redirectTo} replace state={{ from: location }} />;
  }

  return children;
};

export default ValidateAuthSession;
